import { MemberLoadingSpinner } from "@flow/frontend/member/components/MemberLoadingSpinner";
import type { MemberRouteArgs } from "@flow/frontend/member/FrontendMemberRoute";
import { MainContainer } from "@flow/frontend/member/components/MainContainer";
import { memberTheme } from "@flow/frontend/member/memberTheme";
import { Alert, Card, CardMedia, Divider, Typography } from "@mui/material";
import React from "react";
import * as Safe from "safe-portals";
import { submissionTargetVideo } from "../../common/routes";

export function TargetVideoLandingPageComponent(
  props: React.PropsWithChildren<{ submission_guid: string } & MemberRouteArgs>
) {
  const [videoUrl, setVideoUrl] = React.useState<string | undefined>(undefined);
  const [error, setError] = React.useState<string | undefined>(undefined);

  React.useEffect(() => {
    submissionTargetVideo
      .call({ submission_guid: props.submission_guid })
      .then((result) => {
        if (Safe.Result.isOk(result)) {
          setVideoUrl(result.ok.video_url);
        } else {
          setError(result.error);
        }
      })
      .catch((e) => setError("Video file not found"));
  }, []);

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  } else if (videoUrl === undefined) {
    return <MemberLoadingSpinner />;
  } else {
    return (
      <MainContainer sx={{ marginY: "1.5rem" }}>
        <Typography sx={{ typography: { xs: "subtitle1", md: "h5" } }} color={memberTheme.palette.primary.main}>
          Video received
        </Typography>
        <Typography variant="body1">From a 38 Degrees supporter</Typography>
        <Divider />
        <Card>
          <CardMedia component="video" controls autoPlay width="100%" src={videoUrl} />
        </Card>
        <Divider />
      </MainContainer>
    );
  }
}
